import { DealerId } from '@upstart/harmony/lib/legos/dealerTypes';
import { CLIENT_TYPE, Condition } from '@upstart/harmony/lib/legos/constants';
import { CreditPricing } from '@upstart/harmony/lib/legos/creditPricingType';
import BackendService from './BackendService';

export default class DealerPricingService {
  static get({
    dealerId,
    section,
  }: {
    dealerId: DealerId;
    section?: {
      type: CLIENT_TYPE;
      condition: Condition;
      vin?: string;
      year?: string;
      make?: string;
      model?: string;
      trim?: string;
    };
  }) {
    const params = {
      ...section,
    };
    return BackendService.get(`/dealers/${dealerId}/pricing`, {
      params,
      cache: false,
    });
  }

  static update({
    dealerId,
    section,
    creditPricingConfig,
  }: {
    dealerId: string;
    creditPricingConfig: CreditPricing;
    section: {
      type: CLIENT_TYPE;
      condition: Condition;
      vin?: string;
      year?: string;
      make?: string;
      model?: string;
      trim?: string;
    };
  }) {
    return BackendService.put(`/dealers/${dealerId}/pricing`, {
      body: {
        section,
        creditPricingConfig,
      },
    });
  }

  static getByIds = (dealerId: string, body: { configurationIds: string[] }) =>
    BackendService.post(`/dealers/${dealerId}/configurations`, {
      body,
    });
}
